import { Fragment } from "react";
import { Link } from "react-router-dom";
import classes from "./MainNavigation.module.css";
import useTranslation from "./../../customHooks/translations";

const Footer = () => {
  const translation = useTranslation();

  const redirectToNewPageAtNewTab = function (redirectPage) {
    const win = window.open("/" + redirectPage, "_blank");
    win.focus();
    // history.push("/Measurement/${customerGUID}");
  };

  return (
    <Fragment>
      <div className="" style={{ marginBottom: "10px", float: "left" }}>
        <button onClick={() => redirectToNewPageAtNewTab("WorkSteps?step=2")}>
          <span className="badge badge-danger px-2">
            {translation.assignClothToTailor}
          </span>
        </button>
      </div>

      <div className="" style={{ marginBottom: "10px", float: "left" }}>
        <button onClick={() => redirectToNewPageAtNewTab("WorkSteps?step=3")}>
          <span className="badge badge-danger px-2">
            {translation.getReadyCloth}
          </span>
        </button>
      </div>

      <div className="" style={{ marginBottom: "10px" }}>
        <button onClick={() => redirectToNewPageAtNewTab("WorkSteps?step=4")}>
          <span className="badge badge-danger px-2">
            {" "}
            {translation.deliverToCustomer}
          </span>
        </button>
      </div>

      <div style={{ clear: "both" }}> </div>

      <div className="" style={{ marginBottom: "10px", float: "left" }}>
        <button onClick={() => redirectToNewPageAtNewTab("Product")}>
          <span className="badge badge-danger px-2">
            {translation.product_item}
          </span>
        </button>
      </div>

      <div className="" style={{ marginBottom: "10px", float: "left" }}>
        <button
          onClick={() => redirectToNewPageAtNewTab("ProductMeasurementSetting")}
        >
          <span className="badge badge-danger px-2">
            {translation.settings_product_measurement}
          </span>
        </button>
      </div>

      <div className="" style={{ marginBottom: "10px" }}>
        <button onClick={() => redirectToNewPageAtNewTab("SMSBalance")}>
          <span className="badge badge-danger px-2">
            {" "}
            {translation.sms_balance}
          </span>
        </button>
      </div>
      <div className="footer">
        <div className="copyright">
          <p>{translation.copy_right}</p>
        </div>
      </div>
    </Fragment>
  );
};

export default Footer;
